<script lang="ts">
  import { CustomButton, ModalDialog, Separator } from "$components";
  import { type Writable } from "svelte/store";
  export let onConfirm: () => void;
  export let title: string;
  export let isOpen: Writable<boolean>;
  export let isLoading: boolean = false;
  export let cancelText: string = "Avbryt";
  export let confirmText: string;

  export const closeDialog = () => {
    isOpen.set(false);
  };
</script>

{#if $isOpen}
  <ModalDialog onBackdropPressed={closeDialog}>
    <div class="px-[24px] py-[24px] max-mobile:px-[16px]">
      <h2 class="text-[#181818] text-[18px]">{title}</h2>
    </div>
    <Separator />
    <div class="px-[24px] py-[16px] max-mobile:px-[16px]">
      <slot />
      <div class="flex pt-[24px] justify-end">
        <CustomButton
          type="ghost"
          onClick={closeDialog}
          customClass="mr-[8px]"
        >{cancelText}</CustomButton>
        <CustomButton
          type="warning"
          onClick={onConfirm}
          loading={isLoading}
          customClass="w-[200px]"
        >{confirmText}</CustomButton>
      </div>
    </div>
  </ModalDialog>
{/if}
